import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Divider } from 'components/_new/Divider';
import { Box, BoxSection } from 'components/_new/Box';

export const ProgramArticlesSkeleton = () => {
	return (
		<>
			<div className="flex flex-column gap-1">
				<Skeleton width="14rem" height="2rem" className="mb-2" />
				<div className="flex flex-row gap-2 justify-content-start align-content-stretch">
					{[1, 2, 3].map((i) => (
						<div key={i} className="flex article-tile" style={{ flexShrink: 0 }}>
							<Box
								variant="white-bordered"
								className="w-full"
								style={{ width: '280px' }}
								img={() => (
									<div style={{ width: '100%', paddingTop: '36%', position: 'relative' }}>
										<Skeleton
											style={{
												position: 'absolute',
												top: 0,
												left: 0,
												width: '100%',
												height: '100%',
											}}
											borderRadius="0"
										/>
									</div>
								)}
							>
								<BoxSection horizontal contentClassName="justify-content-start">
									<div className="inline-flex gap-2 align-items-center">
										<Skeleton shape="circle" size="1.5rem" />
										<Skeleton shape="circle" size="1.5rem" />
										<Skeleton shape="circle" size="1.5rem" />
									</div>
								</BoxSection>
								<BoxSection>
									<Skeleton width="100%" height="1rem" className="mb-2" />
									<Skeleton width="75%" height="1rem" />
								</BoxSection>
								<BoxSection>
									<Skeleton width="100%" height="2.5rem" borderRadius="0.375rem" />
								</BoxSection>
							</Box>
						</div>
					))}
				</div>
			</div>
			<Divider />
		</>
	);
};
